import { render } from "./SolicitudesIngreso.vue?vue&type=template&id=0ce7e643&scoped=true"
import script from "./SolicitudesIngreso.vue?vue&type=script&lang=js"
export * from "./SolicitudesIngreso.vue?vue&type=script&lang=js"

import "./SolicitudesIngreso.vue?vue&type=style&index=0&id=0ce7e643&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ce7e643"]])

export default __exports__